export default {
  root: {
    height: '100px',
    padding: '0px !important'
  }
};
